// extracted by mini-css-extract-plugin
export var carrierIcon = "_xl-0";
export var carrierLogo = "_xl-1";
export var detailsSection = "_xl-2";